/**
 * Die Aufsichtsbefehle aus Relays Leiste der laufenden Prüfungen (Relay-Nachtrag
 * `docs/specs/2026-10-07-nachtrag-app-leiste-stage.md`). An Stage gehen nur `MESSAGE` und
 * `TIME_ADD`; `PAUSE`, `RESUME` und `KICK` schickt Relay nicht an eine OSCE.
 *
 * Abgeholt, ausgeführt und quittiert werden sie mit den übrigen Gerätebefehlen in
 * `geraeteEinstellungen.ts::gleicheEinstellungenAb` — hier steht nur, was ein Argument gilt.
 */

export const MESSAGE = 'MESSAGE';
export const TIME_ADD = 'TIME_ADD';

/** So lang darf eine Mitteilung sein; Relay sagt es zu, Stage verlässt sich nicht darauf. */
export const MITTEILUNG_MAX = 1000;

/** Höchstens eine halbe Stunde auf einmal — was Relays Leiste anbietet. */
export const ZUGABE_MAX = 1800;

/**
 * Gültige Sekunden einer Zugabe (ganzzahlig, 1…1800) oder `null`.
 *
 * ⚠️ **Ungültiges wird nicht zurechtgebogen.** Ein negativer oder zu grosser Wert ist ein
 * Fehler auf Relays Seite; ihn zu kappen hiesse, eine Zeit zu geben, die niemand gewählt hat.
 * Der Aufrufer quittiert ihn trotzdem (Entscheidung des Nutzers, 2026-10-07) — sonst käme er
 * zwei Stunden lang jede Minute wieder.
 */
export function zugabeSekunden(arg: { seconds?: unknown } | null): number | null {
  const n = arg?.seconds;
  return typeof n === 'number' && Number.isInteger(n) && n >= 1 && n <= ZUGABE_MAX ? n : null;
}

/** Der Text einer Mitteilung, auf 1000 Zeichen gekürzt, oder `null`, wenn keiner da ist. */
export function mitteilungsText(arg: { text?: unknown } | null): string | null {
  const t = arg?.text;
  if (typeof t !== 'string' || t.trim() === '') return null;
  return t.slice(0, MITTEILUNG_MAX);
}
